import { ToastProvider } from "react-toast-notifications";
import Header from "./components/Header";
import About from "./components/About";
import Resume from "./components/Resume";
import Services from "./components/Services"
import Portfolio from "./components/Portfolio";
import Contact from "./components/Contact";
function App() {
  return (
    <ToastProvider>
      <Header />
      <About />
      <Resume />
      <Services />
      <Portfolio />
      <Contact />
    </ToastProvider>
  );
}

export default App;
